/// <reference path="../Container/Container.ts" />
/// <reference path="../Container/CFlexContainer.ts" />
namespace HA.Core.HTML.App {
    export class App extends Container {

        /**
         *
         * @param tag
         */
        public addToContainer(tag: Tag) {
            this.getContainer().addItem(tag);
        }

        /**
         * @returns {List}
         */
        protected getContainer() {
            return this.get("--container");
        }

        protected createSelf() {
            super.createSelf();
            const container = new List();
            this.addToData("--container", container);
            this.appendChild(container);
        }

    }
}
